<template>
  <div>
    <b-form class="mb-3">
      <b-textarea v-model="draftMessage" placeholder="Write a comment..."></b-textarea>
      <b-button @click="post()" v-if="draftMessage.length > 0" variant="primary">Post</b-button>
    </b-form>

    <b-card v-for="note in notes" :key="note.id" class="mt-3">
      <h5>{{note.connector.name}}</h5>
      <p>
        {{note.message}}
      </p>
      <div class="text-muted">{{note.createdAt | moment('from')}}</div>
    </b-card>
  </div>
</template>
<script>
import $auth from '@/services/auth.js';
import {ListMemberNotes, InsertMemberNote, DeleteMemberNote} from '@/gql/members/Notes.gql';

export default {
  props: {
    member: {
        type: Object,
        required: true,
    },
  },
  data() {
    return {
      draftMessage: '',
    };
  },
  methods: {
    async post() {
      await this.$apollo.mutate({
        mutation: InsertMemberNote,
        variables: {
          message: this.draftMessage,
          memberId: this.member.id,
          connectorId: $auth.getUserId()
        }
      });
      this.draftMessage = '';
      this.$apollo.queries.notes.refetch();
    },
  },
  apollo:{
    notes: {
      query: ListMemberNotes,
      variables() {
        return {
          memberId: this.member.id
        }
      }
    }
  }
}
</script>
